import { inject, injectable } from "tsyringe";
import { autoBind } from "src/shared/decorators/autobind";
import { ScratchGameResult } from "src/containers/wellbeing/rewards/domain/models/scratch-game-result";
import { ScratchGameService } from "src/containers/wellbeing/rewards/services/scratch-game-service/scratch-game-service";
import type {
    NotifyGameScratchedParams,
    ScratchGameParams,
    SendWinnerDataParams,
} from "src/containers/wellbeing/rewards/types/scratch";

@injectable()
export class ScratchGameViewModel {
    constructor(
        @inject("ScratchGameService") private gameService: ScratchGameService
    ) {}

    @autoBind
    getGame(
        params: ScratchGameParams,
        useMock = false
    ): Promise<ScratchGameResult> {
        return this.gameService.getGame(params, useMock);
    }

    @autoBind
    notifyGameScratched(params: NotifyGameScratchedParams): Promise<void> {
        return this.gameService.notifyGameScratched(params);
    }

    @autoBind
    sendWinnerData(params: SendWinnerDataParams): Promise<void> {
        return this.gameService.sendWinnerData(params);
    }
}
